import { useQueries } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../web/ReactQueryProvider';
import { IManagedAccountUserReference } from './types';

const BASE_QUERY_KEY = 'ManagedAccount/<managedAccountId>/users';

export function useManagedAccountUsersQueries({
	managedAccountIds,
	enabled = true,
	meta,
}: {
	managedAccountIds: string[];
	enabled?: boolean;
	meta?: LevStandardQueryMeta;
}) {
	const userSession = useUserSession();

	return useQueries({
		queries: managedAccountIds.map(managedAccountId => ({
			queryKey: [BASE_QUERY_KEY, managedAccountId],
			queryFn: () =>
				userSession.webServiceHelper.callAsync<IManagedAccountUserReference[]>({
					path: `ManagedAccount/${managedAccountId}/users`,
					method: 'GET',
				}),
			enabled: enabled && !!managedAccountId,
			meta,
		})),
	});
}
